export default __webpack_public_path__ + "static/media/Group9156.b57870d1.svg";